import React from "react";

function ImportersExporters() {
  return (
    <div className="container Detail">
      <h6>Importers / Exporters</h6>
      <p>Here is the list of importers and exporters in Ethiopia...</p>
    </div>
  );
}

export default ImportersExporters;
